import { ApiFunc, getInstance } from '@helpers/httpClient'
import { prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const recruitmentInquiryCreate: ApiFunc<`${typeof API.RECRUITMENT_INQUIRY}`, 'post'> = data =>
  instance.post(API.RECRUITMENT_INQUIRY, data)

export const recruitmentInquiryList: ApiFunc<`${typeof API.RECRUITMENT_INQUIRY}`, 'get'> = data =>
  instance.get(API.RECRUITMENT_INQUIRY, { params: data })

export const recruitmentInquiryItemDelete: ApiFunc<`${typeof API.RECRUITMENT_INQUIRY}{id}`, 'delete'> = data =>
  instance.delete(`${API.RECRUITMENT_INQUIRY}${'id' in data ? prop('id', data) : prop('name', data)}`)

export const recruitmentInquiryItem: ApiFunc<`${typeof API.RECRUITMENT_INQUIRY}{id}`, 'get'> = data =>
  instance.get(`${API.RECRUITMENT_INQUIRY}${'id' in data ? prop('id', data) : prop('name', data)}`)

export const recruitmentInquiryUpdateStatus: ApiFunc<
  `${typeof API.RECRUITMENT_INQUIRY_UPDATE_STATUS}`,
  'post'
> = data => instance.post(API.RECRUITMENT_INQUIRY_UPDATE_STATUS, data)
